"use strict";
import DataStoreService from "../accounts_payable/data_store_service";
import ApiService from "../services/api_service";
export default {
  save: function(document) {
    return ApiService.addErrorHandler($.ajax({
      url: "/api/documents/" + document.id,
      type: "PUT",
      contentType: "application/json",
      data: JSON.stringify({ document: _.omit(document, ["pages", "exception_events"]) })
    }).then(DataStoreService.responseHandler, _.identity));
  },
  setAsCarrierDocument: function(document, carrierId) {
    return ApiService.addErrorHandler($.ajax({
      url: "/api/documents/" + document.id,
      type: "PUT",
      contentType: "application/json",
      data: JSON.stringify({ carrier_id: carrierId })
    }).then(DataStoreService.responseHandler, _.identity));
  },
  setAssignedToCustomerLoad: function(document, customerLoadId, isAssigned) {
    return ApiService.addErrorHandler($.ajax({
      url: "/api/documents/" + document.id,
      type: "PUT",
      contentType: "application/json",
      data: JSON.stringify({ customer_load_id: customerLoadId, is_assigned: isAssigned })
    }).then(DataStoreService.responseHandler, _.identity));
  },
  setAssignedToShipment: function(document, shipmentId, isAssigned) {
    return ApiService.addErrorHandler($.ajax({
      url: "/api/documents/" + document.id,
      type: "PUT",
      contentType: "application/json",
      data: JSON.stringify({ shipment_id: shipmentId, is_assigned: isAssigned })
    }).then(DataStoreService.responseHandler, _.identity));
  }
};
